export default "__VITE_ASSET__gv4vckFH__"